import React from 'react';
var ThemeContext = /*#__PURE__*/React.createContext(null);
export default ThemeContext;